import { IListing } from "repoV2/features/Listing/Listing.interfaces";
import { IExpressInterestCustomQuestions } from "./IExpressInterestCustomQuestions";

// Get HTML ID for the element. Useful for testing automation
const getID = (indexProp: number): string =>
    `expressInterest-answers-${indexProp}`;

const useCustomQuestions = ({
    questions = [],
    answers,
    showError,
    setAnswers,
    thumbnails,
    setThumbnails,
}: IExpressInterestCustomQuestions.IProps) => {
    const getInputProps = (item: IListing.IQuestion, index: number) => {
        const userInput = answers?.[item.uuid];
        const showInputError = showError && item.is_mandatory;

        return {
            htmlId: getID(index),
            item,
            showInputError,
            userInput,
            answers,
            setAnswers,
            thumbnails,
            setThumbnails,
        };
    };

    return {
        questions,
        getInputProps,
    };
};

export default useCustomQuestions;
